module.exports = __webpack_public_path__ + "img/icon22.ceb7974e.svg";